var map = {
	"./3kittens.jpg": "7848",
	"./another_plush_bunny.png": "0dd1",
	"./background.png": "9855",
	"./banner.png": "1936",
	"./base1-sm.jpg": "34f4",
	"./base2-sm.jpg": "409f",
	"./base3-sm.jpg": "aa0d",
	"./catlia_logo.png": "7e99",
	"./hamster.png": "4185",
	"./icons/crown_coin.png": "9b96",
	"./icons/crown_coin2.png": "55fc",
	"./icons/lunar_coin.png": "ecb7",
	"./icons/mail.png": "fd7a",
	"./icons/nomail.png": "89b3",
	"./icons/nonotif.png": "c5ad",
	"./icons/notif.png": "98f8",
	"./landing.jpg": "4f88",
	"./landing.webp": "5219",
	"./landingpage2.png": "9f23",
	"./landingpage2.webp": "f7e4",
	"./maps/friendlyforest.jpg": "9d55",
	"./maps/friendlyforest.webp": "7c0d",
	"./maps/snowypeak.jpg": "e53d",
	"./maps/snowypeak.webp": "b22a",
	"./maps/temporalsky.jpg": "d232",
	"./maps/temporalsky.webp": "56ab",
	"./maps/worldmap.jpg": "6dd2",
	"./maps/worldmap.webp": "fcd7",
	"./maps/worldmapmobile.jpg": "880c",
	"./maps/worldmapmobile.webp": "7452",
	"./meika.jpg": "9ec9",
	"./meika.png": "615f",
	"./mocha_egg.png": "7586",
	"./princemocha.png": "ef98",
	"./secondkitten_bases.png": "ad0a",
	"./secondkitten_bluebase_25.png": "cbaa",
	"./secondkitten_purplebase_25.png": "be55",
	"./secondkitten_yellowbase_25.png": "5623",
	"./sparkle.png": "7233",
	"./twitter.svg": "1538",
	"./violet_outline_.png": "9bd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";